<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :span=8 label="设备名称" prop="name" :rules="[{
            required: true,
            message: '请输入设备名称'
          }]">
            <el-input v-model.trim="model.name" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备品牌" prop="brand" :rules="[{
            required: true,
            message: '请输入设备品牌'
          }]">
            <el-input v-model.trim="model.brand" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备型号" prop="model" :rules="[{
            required: true,
            message: '请输入设备型号'
          }]">
            <el-input v-model.trim="model.model" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="设备类别" prop="deviceCategoryId" style="width: 100%;" :rules="[{
            required: true,
            message: '请选择设备类别'
          }]">
            <el-select v-model="model.deviceCategoryId" disabled placeholder="请选择设备类别" style="width: 100%;">
              <el-option
                v-for="item in deviceCategories"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="数据频率(单位: 分钟)" prop="dataFrequency" :rules="[{
            required: true,
            message: '请输入设备数据频率'
          }]">
            <el-input v-model.trim="model.dataFrequency" :disabled="!isAdmin" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备最大延迟时间(单位: 分钟)" prop="maxDelayTime" :rules="[{
            required: true,
            message: '请输入设备延迟时间'
          }]">
            <el-input v-model.trim="model.maxDelayTime" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="量程下限" prop="lowRange">
            <el-input v-model.trim="model.lowRange" disabled type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="量程上限" prop="highRange">
            <el-input v-model.trim="model.highRange" disabled type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        v-if="isRadarCategory"
        label="探测高度 单位: 千米（每个高度之间以'|'分割）"
        prop="height"
        :rules="[{
          required: true,
          message: '请输入探测高度'
        }, {
          validator: heightValidator,
          trigger: 'change'
        }]"
      >
        <el-input v-model.trim="model.height" />
      </el-form-item>

      <el-form-item
        v-if="isVOCsCategoryId"
        label="监测因子类别"
      >
        <el-radio-group v-model="model.factorCategory">
          <el-radio label="VOC-CHROMATOGRAPHY">VOC-色谱</el-radio>
          <el-radio label="VOC-MASS-SPECTRUM">VOC-质谱</el-radio>
          <el-radio label="BENZENE-SERIES">苯系物</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>

</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  data () {
    return {
      model: {}
    }
  },
  computed: {
    isVOCsCategoryId () {
      return this.model.deviceCategoryId === process.env.VOCS_DEVICE_CATEGORY
    },
    isRadarCategory () {
      return this.model.deviceCategoryId & (process.env.LIDAR_DEVICE_CATEGORY | process.env.WIND_PROFILE_CATEGORY)
    }
  },
  methods: {
    initModel () {
      return {
        id: null,
        name: ''
      }
    },
    heightValidator (rule, value, callback) {
      // if (!/^(\d+(\.\d+)?\|?)+?(\d+(\.\d+)?)$/.test(value)) {
      //   return callback(new Error('探测高度数据格式不对'))
      // }

      if (value.split('|').some(num => num === '' || !Number.isFinite(Number(num)))) {
        return callback(new Error('探测高度数据格式不对'))
      }

      callback()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/03Device/Editor.vue